export default {
  type: 'trainer',
  fields: {
    avatar_url: 'string',
    full_name: 'string',
    updated_at: 'date',
  },
};
